<div class="h-[calc(100vh-68px)] flex flex-col items-center">
  <div class="flex-grow flex flex-col justify-center items-center gap-y-6">
    <h1 class="text-3xl">
      {{ 'system.messages.welcomeToApplication' | transloco }}
      <app-aurora-text class="font-bold">Come on</app-aurora-text>
    </h1>

    <div class="flex gap-x-4">
      <app-invites></app-invites>
    </div>
  </div>
</div>
